import { LoadingOutlined } from "@ant-design/icons";
import { Checkbox, notification, Select, Spin } from "antd";
import { backupInputTypes, ROLE } from "constants/phase";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";
import Select2 from "react-select";

import CloseModal from "../../../components/icons/CloseModal";

const { Option } = Select;

const EditReservedChannel = (props) => {
  const {
    setEditOpen,
    editOpen,
    options,
    editChannelDetail,
    getInviteUser,
    allUsers,
    setAllUsers,
    setLoder,
    editReservedChannel,
    userSearch,
    setUserSearch,
    fetchChannels,
    loder,
    user,
    getOrganizationsByIds,
    setOrganizationSearch,
    entityId,
  } = props;
  const { currentRole } = useOutletContext();
  const [selectedUser, setSelectedUser] = useState([]);
  const [count, setCount] = useState(0);
  const firstRef = useRef(true);
  const [initialValues, setInitialValues] = useState({
    channelName: "",
    channelId: "",
    inputId: "",
    flowId: "",
    region: "",
    outboundIp: "",
    inputType: "",
    user: "",
    organization: "",
  });
  const [selectOrganization, setSelectOrganization] = useState([]);

  const closeModal = () => {
    setEditOpen(false);
    if (allUsers?.length === 0) {
      setSelectedUser([]);
    }
  };
  const handleChange = (e) => {
    setSelectOrganization(e);
    setInitialValues({ ...initialValues, user: e?.value });
  };
  useEffect(() => {
    const users = [];
    allUsers?.length !== 0 &&
      allUsers?.map((alluser) => {
        users.push({
          value: alluser.userId,
          label: `${alluser.name}-${alluser.email}`,
        });
      });
    setSelectedUser(users);
  }, [allUsers]);

  const handleSubmit = async (values) => {
    setLoder(true);
    const { value } = await editReservedChannel({
      _id: editChannelDetail?._id,
      channelName: values?.channelName,
      channelId: values?.channelId,
      inputId: values?.inputId,
      flowId: values?.flowId,
      outboundIp: values?.outboundIp,
      region: values?.region,
      inputType: values?.inputType,
      entityId: selectOrganization[0]?.value,
      ...(values?.inputType === "RTMP_PUSH" && values?.is_domain ? { is_domain: values.is_domain } : {}),
    });
    if (value.status == true) {
      fetchChannels();
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }
    setLoder(false);
    closeModal();
  };
  useEffect(() => {
    if (editChannelDetail) {
      setInitialValues({
        channelName: editChannelDetail?.channelName,
        channelId: editChannelDetail?.channelId,
        inputId: editChannelDetail?.inputId,
        flowId: editChannelDetail?.flowId,
        outboundIp: editChannelDetail?.outboundIp,
        region: editChannelDetail?.region,
        inputType: editChannelDetail?.inputType,
        organization: editChannelDetail?.entityId,
        is_domain: editChannelDetail?.is_domain,
      });
      if (editChannelDetail?.entityId) {
        getOrganizationData();
      }
    }
  }, [editChannelDetail]);
  const getOrganizationData = async () => {
    //get list of all organizations assiged to server
    const { payload } = await getOrganizationsByIds({
      organizationIds: [editChannelDetail?.entityId],
      includeWorkspaces: true,
    });
    const response = await payload;
    if (response?.value?.status) {
      const orgs = (response?.value?.data?.organizations || [])
        .filter((item) => item.organizationId === editChannelDetail?.entityId)
        .map((item) => ({ label: item.name, value: item.organizationId }));

      setSelectOrganization(orgs);
    }
  };

  useEffect(() => {
    if (editChannelDetail) {
      if (editChannelDetail?.user === "") {
        setAllUsers([]);
      }
    }
  }, [editChannelDetail]);

  useEffect(() => {
    if (firstRef.current) {
      firstRef.current = false;
    } else {
      const timer = setTimeout(() => {
        setCount(count + 1);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [userSearch]);

  useEffect(() => {
    getInviteUser(false);
  }, [count]);

  return (
    <>
      <Modal
        isOpen={editOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        ariaHideApp={false}
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">{`${currentRole !== ROLE.SUPER_ADMIN ? "" : "Edit"} Reserved Channel`}</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
            {({ errors, touched, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">Input Type</label>
                      <Field
                        className="form-control"
                        name="inputType"
                        type="text"
                        placeholder="Enter Input Type"
                        disabled
                      />
                      {touched.inputType && errors.inputType && (
                        <div className="invalid-feedback">{errors.inputType}</div>
                      )}
                    </div>
                    <div className="form-group">
                      {backupInputTypes.includes(values?.inputType) && values?.is_domain && (
                        <div className="form-group">
                          <Checkbox checked={values.is_domain} disabled>
                            <label className="form-label">
                              {" "}
                              <label className="form-label">Domain</label>
                            </label>
                          </Checkbox>
                        </div>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Channel Id</label>
                      <Field
                        className="form-control"
                        name="channelId"
                        type="text"
                        placeholder="Enter Channel Id"
                        disabled={true}
                      />
                      {touched.channelId && errors.channelId && (
                        <div className="invalid-feedback">{errors.channelId}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">Channel Name</label>
                      <Field
                        className="form-control"
                        name="channelName"
                        type="text"
                        placeholder="Enter Channel Name"
                        disabled
                      />
                      {touched.channelName && errors.channelName && (
                        <div className="invalid-feedback">{errors.channelName}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">Input Id</label>
                      <Field
                        className="form-control"
                        name="inputId"
                        type="text"
                        placeholder="Enter Input Id"
                        disabled
                      />
                      {touched.inputId && errors.inputId && <div className="invalid-feedback">{errors.inputId}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">Flow Id</label>
                      <Field className="form-control" name="flowId" type="text" placeholder="Enter Flow Id" disabled />
                      {touched.flowId && errors.flowId && <div className="invalid-feedback">{errors.flowId}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">Outbound Ip</label>
                      <Field
                        className="form-control"
                        name="outboundIp"
                        type="text"
                        placeholder="127.0.0.1:3004"
                        disabled
                      />
                      {touched.outboundIp && errors.outboundIp && (
                        <div className="invalid-feedback">{errors.outboundIp}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">AWS Region</label>
                      <Field
                        className="form-control"
                        name="region"
                        type="text"
                        disabled={true}
                        placeholder="Enter Region"
                      />
                      {touched.region && errors.region && <div className="invalid-feedback">{errors.region}</div>}
                    </div>
                    {currentRole === ROLE.SUPER_ADMIN ? (
                      <div className="form-group">
                        <label className="form-label">
                          Organizations<span className="required"></span>
                        </label>
                        <Select2
                          styles={{ width: "100%" }}
                          // isMulti={true}
                          bordered={false}
                          value={selectOrganization}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onInputChange={(e) => {
                            setOrganizationSearch(e);
                          }}
                          name="organization"
                          options={options}
                        />
                        {/* {touched.user && errors.user && <div className="invalid-feedback">{errors.user}</div>} */}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      {currentRole === ROLE.SUPER_ADMIN && (
                        <React.Fragment>
                          <button type="button" className="btn btn-white" onClick={closeModal}>
                            Cancel
                          </button>

                          <button type="submit" className="btn btn-primary">
                            Edit
                            {loder == false ? (
                              ""
                            ) : (
                              <Spin
                                size="large"
                                indicator={
                                  <LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />
                                }
                                className="loader__full"
                              ></Spin>
                            )}
                          </button>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default EditReservedChannel;
